import { ApiClientService, EntityApiService } from '@dfl/react-security';
import { IProviderField } from '../interfaces/IProviderField';
import { PROVIDER_TYPE_ENUM } from 'modules/inventory/provider/common/constants/provider.types';

class ProviderFieldService extends EntityApiService<IProviderField> {
  getByType = (providerType: PROVIDER_TYPE_ENUM): Promise<IProviderField[]> => {
    return this.handleResponse(
      ApiClientService.get(this.getPath(`/by-type/${providerType}`)),
    ).then((res: any) => res?.data ?? res ?? []);
  };
}

export default new ProviderFieldService('/ms-inventory/api/provider-fields');
